// extracted by mini-css-extract-plugin
export default {"questionContainer":"questionContainer__ZLn0W"};